import React, {useState} from 'react';
import {Separator, Icons, Flex, Lists, Layout} from 'components';
import {useNamedSelector, printSidebar, useList} from 'helpers';

export function Sidebar() {
  let heading = '';
  const [ q, setSearch ] = useState('');

  const lists = useNamedSelector('lists.lists');

  const [ list, Last ] = useList(lists, {
    search: { q, keys: ['name'] },
  });

  return (
    <Layout.Sidebar>
      <Flex className={['secondary', 'middle']}>
        <Layout.Sidebar.Search value={q} setValue={setSearch} />
        <Icons.Print onClick={printSidebar} />
        <Lists.SidebarPreferences />
        <Icons.PlusLarge title="Add List" to={'/lists/add/'} />
      </Flex>
      <Layout.Sidebar.Scrollable>
        { lists.length === 0 && <p className="text-center secondary">You have no lists.</p> }
        { list.map(list => list.heading !== undefined
          ? <Separator key={heading = list.heading} heading={list.heading} />
          : <Lists.Card key={heading + list.id} {...list} />
        ) }
        <Last />
      </Layout.Sidebar.Scrollable>
    </Layout.Sidebar>
  );
}
